import {Controller} from '@hotwired/stimulus';

/**
 * Case « Tout sélectionner » d'un groupe de cases à cocher : la cocher coche tout le groupe, la décocher le décoche.
 * Elle suit l'état du groupe, mixte (`indeterminate`) quand une partie seulement est cochée,
 * décochée quand le groupe est vide.
 *
 *   <fieldset {{ stimulus_controller('check-all') }} {{ stimulus_action('check-all', 'update', 'change') }}>
 *     <input type="checkbox" {{ stimulus_target('check-all', 'all') }}> <label>Tout sélectionner</label>
 *     <input type="checkbox" {{ stimulus_target('check-all', 'item') }}> …
 *   </fieldset>
 *
 * En option, la barre d'actions groupées d'une table (table.md › Sélection) : les cibles `action` ne paraissent
 * qu'avec une case cochée au moins, et la cible `count`, une région `role="status"`, nomme le nombre de cases
 * cochées (values `countOne` et `countOther`, où `{count}` est remplacé), vide sans sélection.
 *
 * Une liste rechargée sur place remplace ses cases : la case « Tout sélectionner », les actions et le compteur
 * suivent les cases ajoutées ou retirées.
 */
export default class extends Controller {
  static targets = ['all', 'item', 'action', 'count'];

  static values = {
    countOne: String,
    countOther: String,
  };

  connect() {
    this.sync();
  }

  allTargetConnected() {
    this.sync();
  }

  itemTargetConnected() {
    this.sync();
  }

  itemTargetDisconnected() {
    this.sync();
  }

  update({target}) {
    if (this.hasAllTarget && target === this.allTarget) {
      this.itemTargets.forEach((item) => {
        item.checked = this.allTarget.checked;
      });
    }

    this.sync();
  }

  sync() {
    const checked = this.itemTargets.filter((item) => item.checked).length;

    if (this.hasAllTarget) {
      this.allTarget.checked = checked > 0 && checked === this.itemTargets.length;
      this.allTarget.indeterminate = checked > 0 && checked < this.itemTargets.length;
    }

    this.actionTargets.forEach((action) => {
      action.hidden = checked === 0;
    });

    if (this.hasCountTarget) {
      const label = checked === 1 ? this.countOneValue : this.countOtherValue;

      this.countTarget.textContent = checked === 0 ? '' : label.replaceAll('{count}', String(checked));
    }
  }
}
